import React from 'react'
import { FormattedMessage } from 'react-intl'

import Container from 'components/Container'
import Row from 'components/Row'
import Col from 'components/Col'

import LoginForm from './components/loginForm'
import { AcknowledgementWrapper, AcknowledgementText } from './style'

const LoginPage = () => {
  return (
    <Container>
      <Row>
        <Col md={8} mdOffset={2} paddingLeft={48} paddingRight={48}>
          <LoginForm />
        </Col>
      </Row>
      <AcknowledgementWrapper>
        <AcknowledgementText>
          <FormattedMessage id="acknowledgementText" />
        </AcknowledgementText>
      </AcknowledgementWrapper>
    </Container>
  )
}

export default LoginPage
